export default __webpack_public_path__ + "static/media/may2023-5.ed96c932.jpg";